export default function getFormattedPropertyTypes({ propertyTypes = [] }) {
  return propertyTypes.map(propertyType => propertyType.displayText).join(', ');
}
